module.exports = __webpack_public_path__ + "public/SiteIcons/deleteWishIcon.svg?9b81f256";